module.exports = __webpack_public_path__ + "img/banner3.7e61b2ab.png";